import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { adminRewrite, onAdminHost } from "@/lib/adminHost";
import { ApiError } from "@/lib/api/errors";
import { routeTree } from "./routeTree.gen";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      // Retry transient failures only; a 4xx will not fix itself.
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500 && err.status !== 429) && count < 2,
      refetchOnWindowFocus: true,
    },
    mutations: { retry: false },
  },
});

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  // On admin.guv.dev the console sits at the root; see lib/adminHost.
  rewrite: onAdminHost ? adminRewrite : undefined,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
  interface StaticDataRouteOption {
    /** Breadcrumb and document title for the route. */
    title?: string;
  }
}
